module.exports = __webpack_public_path__ + "static/media/動物頭像生成.1d571fea.png";